import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import Shimmer from "react-shimmer-effect";
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar'

import { accessRole } from "../../../../../helpers/access_role"
import DatePicker from '../../../../../helpers/ui/DatePicker'

var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

const jobType = [
    { value: 1, label: 'PNS BKPM' },
    { value: 2, label: 'PNS Non BKPM' },
    { value: 3, label: 'Non PNS' },
    { value: 4, label: 'Tidak Bekerja'}
]



class IndexView extends Component {

    updateBloc = new UpdateBloc();

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")



    constructor(props) {
        super(props)
        this.state = {
            luarNegeri:"",
            dalamNegeri:"",
            dataForm: {},
            optionGender : [
              { label: "Laki-laki", value: "L" },
              { label: "Perempuan", value: "P" }
            ],
            optionPosition : [
                { label: "Ayah", value: "1" },
                { label: "Ibu", value: "2" },
            ],
            optionTempatLahir : [
                { label: "Dalam Negeri", value: "1" },
                { label: "Luar Negeri", value: "2" }
              ],
            selectedGender: "",
            selectedPosition: "",
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: "",
            birthOptionCountry: [],
            birthSelectedCountry: "",
            birthOptionProvince2 : [],
            birthSelectedProvince2: "",
            birthOptionCity2 : [],
            birthSelectedCity2: ""
        }
    }

    // Select Area

    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.updateBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
     

    }

    handleBirthSelectProvince2 = (birthSelectedProvince) => {
        this.setState({
            birthSelectedProvince2: birthSelectedProvince.value
        });
  
        // get data city where province selected
        this.updateBloc.regionCityChannel2.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionCity2: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionCity2({
          is_local: 1,
          type : 3,
          parent_uuid : birthSelectedProvince.value
        })
      }

    
    handleBirthSelectCountry = (birthSelectedCountry) => {
        this.setState({
            birthSelectedCountry: birthSelectedCountry.value
        });
    }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleBirthSelectCity2 = (birthSelectedCity) => {
        this.setState({
          birthSelectedCity2: birthSelectedCity.value
        });
      }

    handleSelectGender = (selectedGender) => {
      this.setState({
        selectedGender: selectedGender.value
      });
    }

    handleSelectTempatLahir = (selectedTempatLahir) => {
        var status = parseInt(selectedTempatLahir.value)
        if(status === 1){
            // Dalam Negeri
            this.updateBloc.fetchRegionCountries({
                type : 1  
            })
            this.setState({
                selectedTempatLahir: selectedTempatLahir.value,
                luarNegeri: "",
                dalamNegeri:"none",
                birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3"
            });
            
        }else{
             // Luar Negeri
            this.setState({
                selectedTempatLahir: selectedTempatLahir.value,
                luarNegeri: "none",
                dalamNegeri:"",
                birthSelectedCountry: ""
            });
            this.updateBloc.fetchRegionCountries({
                is_local: 0, 
                type : 1  
            })
        }
        this.setState({
            selectedTempatLahir: selectedTempatLahir.value
        });
      }

    handleSelectPosition = (selectedPosition) => {
        this.setState({
            selectedPosition: selectedPosition.value
        });
      }

    // End Select Area

    submitData = async () => {
        if(this.state.dataForm.document.length > 0){
            let formData = generateFormData(this.state.dataForm, 'document')
            await this.updateBloc.fetchUpdate(formData)
        }else{
            await this.updateBloc.fetchUpdate(this.state.dataForm)
        }     
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        // get data province
        this.updateBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.regionProvinceChannel2.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionProvince2: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            luarNegeri:"",
                            dalamNegeri:"",
                            dataForm: {
                                uuid: response.family_uuid,
                                employee_uuid: response.family_employee_uuid,
                                family_position: response.family_gender,
                                family_gender_number: response.family_gender_number,
                                family_name: response.family_name,
                                family_parent_type: response.family_parent_type,
                                family_date_of_birth: response.family_date_of_birth,
                                family_place_of_birth_national: response.family_place_of_birth_national,
                                family_is_alive: response.family_is_alive ? response.family_is_alive : 1,
                                family_spouse_job_type: response.family_spouse_job_type,
                                family_identity_address: response.family_identity_address,
                                family_identity_postal_code: response.family_identity_postal_code,
                                family_phone_number: response.family_phone_number,
                                documents_path: response.document?response.document.documents_path:null,
                                family_status: response.family_status,
                                family_status_description: response.family_status_description,
                                family_identity_number: response.family_identity_number,
                                familty_family_card_number: response.familty_family_card_number
                            },
                            selectedGender : response.family_gender,
                            selectedPosition : response.family_gender,
                            birthSelectedProvince : response.family_identity_province_uuid,
                            family_place_of_birth_city_uuid: response.family_place_of_birth_city_uuid,
                            birthSelectedCountry: response.family_place_of_birth_country_uuid,
                            birthSelectedProvince2: response.family_identity_province_uuid,
                            birthSelectedCity2: response.family_place_of_birth_city_uuid,
                            birthSelectedCity: response.family_identity_city_uuid,
                           
                        })

                        if(response.family_place_of_birth_national){
                            this.setState({
                                selectedTempatLahir: "1",
                                luarNegeri: "",
                                dalamNegeri:"none"
                            });
                        }else{
                            this.setState({
                                selectedTempatLahir: "2",
                                luarNegeri: "none",
                                dalamNegeri:""
                            });
                        }

                      

                    }
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

        const search = window.location.search
        const queryParams = new URLSearchParams(search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
        
        // get data city where province selected
        this.updateBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionCity: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.regionCityChannel2.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionCity2: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionCountry: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

        this.updateBloc.fetchRegionProvince({
            is_local: 1,
            type : 2  
        })

        this.updateBloc.fetchRegionProvince2({
            is_local: 1,
            type : 2  
        })

        this.updateBloc.fetchRegionCountries({
            type : 1  
        })

        this.updateBloc.fetchRegionCity({
            is_local: 1,
            type : 3
        })

        this.updateBloc.fetchRegionCity2({
            is_local: 1,
            type : 3
        })
       
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="orangtua"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Edit Orang Tua</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                        <AvForm
                                            className="needs-validation"
                                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                        >

                                            
                                        
                                        <AvField
                                                name="uuid"
                                                type="hidden"
                                                id="uuid"
                                                value={this.state.dataForm.uuid}
                                        />
                                        <AvField
                                                name="employee_uuid"
                                                type="hidden"
                                                id="employee_uuid"
                                                value={this.state.dataForm.employee_uuid}
                                        />

                                            {this.state.dataForm.family_status == 2 ?
                                            <Row className="mb-3">
                                                <Col md="12">
                                                    <div class="alert-dismissible fade show alert alert-danger alert-dismissible fade show" role="alert">
                                                        <button type="button" class="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                                                        <i class="uil uil-exclamation-octagon me-2"></i> Catatan Approval : {this.state.dataForm.family_status_description}
                                                    </div>
                                                </Col>
                                            </Row>
                                            : '' }
                                       

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Nama Lengkap <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_name"
                                                        placeholder="Nama..."
                                                        type="text"
                                                        errorMessage="Masukkan Nama"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="name"
                                                        value={this.state.dataForm.family_name}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Posisi Dalam Keluarga <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">

                                                     <AvField
                                                        name="family_position"
                                                        type="text"
                                                        errorMessage="Pilih Posisi Dalam Keluarga"
                                                        id="position_name"
                                                        readonly="readonly"
                                                        value={this.state.dataForm.family_parent_type}
                                                    />
                                                   
                                                    <AvField
                                                        name="family_gender"
                                                        type="hidden"
                                                        errorMessage="Pilih Posisi Dalam Keluarga"
                                                        id="position"
                                                        readonly="readonly"
                                                        value={this.state.dataForm.family_gender}
                                                    />
                                                </Col>
                                            </Row> */}

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Posisi Dalam Keluarga <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        name="family_gender"
                                                        validate={{ required: { value: true } }}
                                                        options={[
                                                            { value: 'P', label: 'Ibu' },
                                                            { value: 'L', label: 'Ayah' },
                                                        ]}
                                                        defaultValue={this.state.dataForm.family_gender_number}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Induk Kependudukan
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                    name="family_identity_number"
                                                    placeholder="Nomor Induk Kependudukan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Induk Kependudukan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="family_identity_number"
                                                    value={this.state.dataForm.family_identity_number}
                                                    />
                                                </Col>
                                                </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Kartu Keluarga 
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="4">
                                                    <AvField
                                                    name="familty_family_card_number"
                                                    placeholder="Nomor Kartu Keluarga..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Kartu Keluarga"
                                                    className="form-control"
                                                    id="familty_family_card_number"
                                                    value={this.state.dataForm.familty_family_card_number}
                                                    />
                                                </Col>
                                            </Row>



                                            <hr />
                                            <Row>
                                                <Col md="5">
                                                    <label className="fw-bold">#Tempat & Tanggal Lahir</label>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Dalam / Luar Negeri <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        name="family_place_of_birth_national"
                                                        defaultValue={this.state.selectedTempatLahir}
                                                        options={this.state.optionTempatLahir}
                                                        onChange={opt => this.handleSelectTempatLahir(opt)}
                                                        placeholder="Pilih Dalam / Luar Negeri"
                                                    />
                                                </Col>
                                            </Row>

                                            {  
                                                !this.state.dalamNegeri &&
                                                    <Row className="mb-3">
                                                        <label
                                                            htmlFor=""
                                                            className="col-md-3 col-form-label"
                                                        >
                                                        Negara <span className="text-danger">*</span>
                                                        </label>
                                                        <Col md="5">
                                                            <CustomSelect 
                                                                name="family_place_of_birth_country_uuid"
                                                                defaultValue={this.state.birthSelectedCountry}
                                                                options={this.state.birthOptionCountry}
                                                                placeholder="Negara.."
                                                                onChange={opt => this.handleBirthSelectCountry(opt)}
                                                            />
                                                        </Col>
                                                    </Row>
                                            }

                                            {
                                                this.state.dalamNegeri &&
                                                    <Row className="mb-3">
                                                        <label
                                                            htmlFor=""
                                                            className="col-md-3 col-form-label"
                                                        >
                                                        Provinsi 
                                                        </label>
                                                        <Col md="5">
                                                            <CustomSelect 
                                                                name="family_place_of_birth_province"
                                                                defaultValue={this.state.birthSelectedProvince2}
                                                                options={this.state.birthOptionProvince2}
                                                                placeholder="Provinsi Lahir..."
                                                                onChange={opt => this.handleBirthSelectProvince2(opt)}
                                                            />
                                                        </Col>
                                                    </Row>
                                            }

                                            {
                                                this.state.dalamNegeri &&
                                                    <Row className="mb-3">
                                                        <label
                                                            htmlFor=""
                                                            className="col-md-3 col-form-label"
                                                        >
                                                        Kabupaten / Kota 
                                                        </label>
                                                        <Col md="5">
                                                            <CustomSelect 
                                                                name="family_place_of_birth_city_uuid"
                                                                defaultValue={this.state.birthSelectedCity2}
                                                                options={this.state.birthOptionCity2}
                                                                placeholder="Kota Lahir..."
                                                                onChange={opt => this.handleBirthSelectCity2(opt)}
                                                            />
                                                        </Col>
                                                    </Row>
                                            }

                                            {
                                                !this.state.dalamNegeri &&
                                                    <Row className="mb-3">
                                                        <label
                                                            htmlFor=""
                                                            className="col-md-3 col-form-label"
                                                        >
                                                        Kota 
                                                        </label>
                                                        <Col md="5">
                                                            <AvField
                                                                name="keluarga_orangtua_of_birth_regency_name"
                                                                placeholder="Kota..."
                                                                type="text"
                                                                errorMessage="Masukkan Kota"
                                                                className="form-control"
                                                                id="keluarga_orangtua_of_birth_regency_name"
                                                                value={this.state.dataForm.keluarga_orangtua_of_birth_regency_name}
                                                            />
                                                        </Col>
                                                    </Row>
                                            }
           

                                            <hr />

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Tanggal Lahir <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    {/* <AvField
                                                        name="family_date_of_birth"
                                                        placeholder="Tanggal Lahir..."
                                                        type="date"
                                                        errorMessage="Masukkan Tanggal Lahir"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        value={this.state.dataForm.family_date_of_birth}
                                                    /> */}
                                                    <DatePicker 
                                                        name={`family_date_of_birth`}
                                                        isWeekday={false}
                                                        dateFormat="dd/MM/yyyy"
                                                        errorMessage="Masukan Tanggal Lahir"
                                                        validate={{ required: { value: true } }}
                                                        defaultValue={this.state.dataForm.family_date_of_birth}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Status <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect
                                                        name="family_is_alive"
                                                        placeholder="Status..."
                                                        errorMessage="Masukkan Status"
                                                        validate={{ required: { value: true } }}
                                                        defaultValue={this.state.dataForm.family_is_alive}
                                                        options={[
                                                            { value: 1, label: 'Hidup' },
                                                            { value: 0, label: 'Meninggal' },
                                                        ]}
                                                    />
                                                </Col>
                                            </Row>

                                            <hr />
                                            <Row>
                                                <Col md="5">
                                                    <label className="fw-bold">#Informasi Lainnya</label>
                                                </Col>
                                            </Row> 

 
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Pekerjaan <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect
                                                        name="family_spouse_job_type"
                                                        placeholder="Pekerjaan..."
                                                        errorMessage="Masukkan Pekerjaan"
                                                        validate={{ required: { value: true } }}
                                                        defaultValue={this.state.dataForm.family_spouse_job_type}
                                                        options={jobType}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Provinsi <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        name="family_identity_province_uuid"
                                                        options={this.state.birthOptionProvince}
                                                        onChange={opt => this.handleBirthSelectProvince(opt)}
                                                        placeholder="Provinsi Tinggal ..."
                                                        errorMessage="Masukkan Provinsi Tinggal"
                                                        validate={{ required: { value: true } }}
                                                        defaultValue={this.state.birthSelectedProvince}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Kabupaten / Kota <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        name="family_identity_city_uuid"
                                                        defaultValue={this.state.birthSelectedCity}
                                                        options={this.state.birthOptionCity}
                                                        onChange={opt => this.handleBirthSelectCity(opt)}
                                                        placeholder="Kota Tinggal ..."
                                                        errorMessage="Masukkan Kota Tinggal"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Kode Pos <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_identity_postal_code"
                                                        placeholder="Kode Pos..."
                                                        type="text"
                                                        errorMessage="Masukkan Kode Pos"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="postal_code"
                                                        value={this.state.dataForm.family_identity_postal_code}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Telepon <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_phone_number"
                                                        placeholder="Nomor Telepon..."
                                                        type="text"
                                                        errorMessage="Masukkan Nomor Telepon"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="phone"
                                                        value={this.state.dataForm.family_phone_number}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Alamat Lengkap <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_identity_address"
                                                        value={this.state.dataForm.family_identity_address}
                                                        placeholder="Alamat..."
                                                        type="textarea"
                                                        errorMessage="Masukkan Alamat"
                                                        className="form-control"
                                                        rows="8"
                                                        validate={{ required: { value: true } }}
                                                        id="address"
                                                    />
                                                </Col>
                                            </Row>

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            File Dokumen <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="document"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Dokumen Terupload
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.dataForm ?
                                                        <>{this.state.dataForm.documents_path != null ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.dataForm.documents_path}>
                                                            <i className="uil-file-download"></i> Download File
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            {/* <Col md="9">
                                                {
                                                    this.state.dataForm ?
                                                        <>{this.state.detail?.document != null ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.dataForm.document.documents_path}>
                                                            <i className="uil-file-download"></i> Download File
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col> */}
                                        </Row>

                                      
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?orangtua">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?orangtua'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView